import {useCallback, useEffect, useState} from "react";

// Название для локального хранилища
const STORAGE_KEY = "searchHistory";
// Сколько записей хранить
const MAX_LENGTH = 5;

export default function useSearchHistory() {
    const [history, setHistory] = useState([]);

    // Инициализация из localStorage
    useEffect(() => {
        try {
            const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
            if (Array.isArray(saved)) {
                setHistory(saved);
            }
        } catch {
            setHistory([]);
        }
    }, []);

    // Сохранение истории
    const saveHistory = useCallback((data) => {
        setHistory(data);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }, []);

    // Добавить новую фразу
    const addSearchTerm = useCallback(
        (term) => {
            if (!term?.trim()) return;

            let newHistory = [...history];

            // Удаляем дубликаты (регистр не учитываем)
            newHistory = newHistory.filter(
                (item) => item.toLowerCase() !== term.toLowerCase()
            );

            // Добавляем в начало
            newHistory.unshift(term.trim());

            // Ограничиваем длину
            if (newHistory.length > MAX_LENGTH) {
                newHistory = newHistory.slice(0, MAX_LENGTH);
            }

            saveHistory(newHistory);
        },
        [history, saveHistory]
    );

    // Удалить один элемент
    const removeTerm = useCallback(
        (term) => {
            const newHistory = history.filter((item) => item !== term);
            saveHistory(newHistory);
        },
        [history, saveHistory]
    );

    // Очистить всю историю
    const clearHistory = useCallback(() => {
        saveHistory([]);
    }, [saveHistory]);

    return {
        history,
        addSearchTerm,
        removeTerm,
        clearHistory,
    };
}
